import React from "react";
import Img2 from "./trainee.png";
// import Img3 from "./image194.png";
import Img3 from "./imgs/image194.png";
import Img1 from "./imgs/image187.png";
import Img4 from "./imgs/image188.png";
import Img5 from "./imgs/image189.png";
import Img6 from "./imgs/image190.png";
import Img7 from "./imgs/image191.png";
import Img8 from "./imgs/image192.png";
import Img9 from "./imgs/image193.png";
import Img10 from "./imgs/image195.png";
import Img11 from "./imgs/image196.png";
import Img12 from "./imgs/image197.png";
import Img13 from "./imgs/image198.png";
import Img14 from "./imgs/image199.png";
import Img15 from "./imgs/image200.png";
import Img16 from "./imgs/image201.png";
import Img17 from "./imgs/image204.png";
import Img18 from "./imgs/image203.png";
import Img19 from "./imgs/image202.png";
import Img20 from "./imgs/image205.png";
import Img21 from "./imgs/image206.png";
import Img22 from "./imgs/image167.png";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Container from "react-bootstrap/Container";
import "./trainee.css";
import { Link } from "react-router-dom";
const Trainee = () => {
  const Data = [
    {
      Img: Img1,
      name: "Pallavi Das",
      fathername: "Shashi Kant Lal Das",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Science",
      Batch: "2019-2023",
      TrainingDate: "19/09/2022 to 24/11/2022",
    },
    {
      Img: Img3,
      name: "Vasu Vatsal Sharma",
      fathername: "Saurabh Sharma",
      University:
        "Maharashtra Institute of Technology Art Design Technology/ Institute of Design",
      Batch: "2021-2025",
      TrainingDate: "14/12/22 to 28/12/22",
    },
    {
      Img: Img4,
      name: "Abhishek Anand",
      fathername: "Arvind Kumar Bharti",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Science",
      Batch: "2019-2023",
      TrainingDate: "07/09/2022 to 14/11/2022",
    },
    {
      Img: Img5,
      name: "Abhijeet Gaurav",
      fathername: "Shailesh Kumar",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Science",
      Batch: "2019-2023",
      TrainingDate: "19/09/2022 to 24/11/2022",
    },
    {
      Img: Img6,
      name: "Mahima Trivedi",
      fathername: "Kumud Kumar Trivedi",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Science",
      Batch: "2019-2023",
      TrainingDate: "19/09/2022 to 24/11/2022",
    },
    {
      Img: Img7,
      name: "Shilpy Kumari",
      fathername: "Suman Kumar Pandey",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Science",
      Batch: "2019-2023",
      TrainingDate: "19/09/2022 to 24/11/2022",
    },
    {
      Img: Img8,
      name: "Shivani Kumari",
      fathername: "Gopal Yadav",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Science",
      Batch: "2019-2023",
      TrainingDate: "19/09/2022 to 24/11/2022",
    },
    {
      Img: Img9,
      name: "Siddhi Jha",
      fathername: "Mohan Kumar Jha",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Science",
      Batch: "2019-2023",
      TrainingDate: "19/09/2022 to 24/11/2022",
    },
    {
      Img: Img10,
      name: "Mohammad Faeez Warsi",
      fathername: "Faisal Warsi",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2021-2025",
      TrainingDate: "21/02/2023 to 21/03/2023",
    },
    {
      Img: Img11,
      name: "Aadarsh Kumar",
      fathername: "Shiv Shankar Prasad",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2019-2023",
      TrainingDate: "05/01/2023 to 05/05/2023",
    },
    {
      Img: Img12,
      name: "Anannya Bhardwaj",
      fathername: "Satendra Panday",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2019-2023",
      TrainingDate: "05/01/2023 to 10/05/2023",
    },
    {
      Img: Img13,
      name: "Suruchi Kumari",
      fathername: "Dharamaveer Kumar",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2019-2023",
      TrainingDate: "05/01/2023 to 05/05/2023",
    },
    {
      Img: Img14,
      name: "Tushar Agrawal",
      fathername: "Mr. Rajeev Agrawal",
      University: "University of Allahabad",
      Batch: "2020-2023",
      TrainingDate: "01/03/2023 to 31/05/2023",
    },
    {
      Img: Img15,
      name: "Ayushi Priya",
      fathername: "Sunil Kumar",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2019-2023",
      TrainingDate: "15/01/2023 to 30/05/2023",
    },
    {
      Img: Img16,
      name: "Ashana Nelson",
      fathername: "Mr. Late Deepak Nelson",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2019-2023",
      TrainingDate: "16/01/2023 to 30/05/2023",
    },
    {
      Img: Img17,
      name: "Ayushi Pandey",
      fathername: "Mukesh Pandey",
      University: "University of Allahabad",
      Batch: "2020-2023",
      TrainingDate: "01/03/2023 to 31/05/2023",
    },
    {
      Img: Img18,
      name: "Vikas Kumar",
      fathername: "Ram Bhadur Prasad",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2021-2025",
      TrainingDate: "01/06/2023 to 30/06/2023",
    },
    {
      Img: Img19,
      name: "Deepasa Chourasia",
      fathername: "Sanjay Kumar Chourasia",
      University:
        "Sam Higginbottom University of Agriculture, Technology and Sciences (Deemed to be University)",
      Batch: "2021-2025",
      TrainingDate: "01/06/2023 to 30/06/2023",
    },
    {
      Img: Img20,
      name: "Kanchan Bisht",
      fathername: "Pratap Singh Bisht",
      University: "University of Allahabad (Science Faculty)",
      Batch: "2021-2026",
      TrainingDate: "16/06/2023 to 30/06/2023",
    },
    {
      Img: Img21,
      name: "Saniya Hasan",
      fathername: "Kamrul Hasan",
      University: "University of Allahabad (Science Faculty)",
      Batch: "2021-2026",
      TrainingDate: "16/06/2023 to 30/06/2023",
    },
    {
      Img: Img22,
      name: "Atika Athar",
      fathername: "Mohd. Athar",
      University: "University of Allahabad (Science Faculty)",
      Batch: "2021-2026",
      TrainingDate: "16/06/2023 to 30/06/2023",
    },
  ];

  return (
    <>
      <Navb />

      <div className="traniee">
        <Container className="whiteHeading">Nandi Agro Trainee</Container>
        <Container className="whiteP">
          "Nandi Agro Trainee" refers to an individual undergoing training or
          apprenticeship within Nandi Agro, a company presumably involved in
          agriculture or related fields. As a trainee at Nandi Agro, one would
          have the opportunity to learn and develop skills in various aspects of
          agricultural practices. The training may include hands-on experience,
          classroom instruction, mentorship, and exposure to the latest trends
          and innovations in the agricultural industry. Nandi Agro is committed
          to nurturing and empowering future agricultural leaders, equipping
          trainees with the knowledge and expertise to contribute positively to
          the sector.
        </Container>
      </div>
      <Container>
        <div className="alltranieimg">
          {Data.map((trainee, index) => (
            <div className="traineeImg" key={index}>
              <Link
                to={{
                  pathname: `/trainee/${trainee.name}`,
                }}
                state={{ trainee }}
              >
                <img
                  src={trainee.Img}
                  className="alltranieimgs"
                  alt={trainee.Img}
                />
              </Link>
            </div>
          ))}
        </div>
      </Container>
      {/* <div className="traineeImg">
        <a href="/trainee/${Data.">
          <img src={Img2} alt="Img2" />
        </a>
      </div> */}
      <Footer />
    </>
  );
};

export default Trainee;
